import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { EMAIL } from '@/content/site';

/**
 * What this site actually stores. It used to describe analytics, marketing and
 * advertising cookies the site has never set; a policy that claims tracking
 * that does not exist is as wrong as one that hides tracking that does. If
 * analytics are ever added, this page and a consent banner come back with them.
 */
export function CookiePolicy() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main id="main" className="flex-grow">
        <article className="mx-auto max-w-3xl px-6 py-20">
          <h1 className="lp-h2">Cookie policy</h1>

          <div className="lp-desc mt-10 space-y-8">
            <section>
              <h2 className="font-display text-lg font-semibold text-foreground">The short version</h2>
              <p className="mt-2">
                agicafet.com sets no cookies and loads no analytics, advertising or tracking scripts. Reading this
                site stores nothing on your device.
              </p>
            </section>

            <section>
              <h2 className="font-display text-lg font-semibold text-foreground">Account pages</h2>
              <p className="mt-2">
                If you sign in on the account pages (/auth), our sign-in provider, Supabase, keeps your session in
                your browser’s local storage so you stay signed in. Signing out removes it. Nothing is stored if you
                never sign in.
              </p>
            </section>

            <section>
              <h2 className="font-display text-lg font-semibold text-foreground">Links to other sites</h2>
              <p className="mt-2">
                Links to premize.agicafet.com, Facebook and other sites take you to pages with their own policies.
                Links to PreMize carry a <code className="font-mono text-[0.9em]">utm_content</code> label in the address
                so we know which part of this page you came from; that label is not a cookie.
              </p>
            </section>

            <section>
              <h2 className="font-display text-lg font-semibold text-foreground">Questions</h2>
              <p className="mt-2">
                Email{' '}
                <a href={`mailto:${EMAIL}`} className="text-primary hover:underline">
                  {EMAIL}
                </a>
                .
              </p>
            </section>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
